module.exports = __webpack_public_path__ + "static/media/月台高度.16735448.svg";